import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { useGetAccountQuery, useGetEsgQuestionnaireResultsForVenturesQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'KeyFacts',
  setup: function setup(__props) {
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var _useGetAccountQuery = useGetAccountQuery(),
      result = _useGetAccountQuery.result;
    var _useGetEsgQuestionnai = useGetEsgQuestionnaireResultsForVenturesQuery(),
      esgQuestionnairesResult = _useGetEsgQuestionnai.result;
    var esgQuestionnaires = computed(function () {
      var _esgQuestionnairesRes, _esgQuestionnairesRes2;
      return (_esgQuestionnairesRes = (_esgQuestionnairesRes2 = esgQuestionnairesResult.value) === null || _esgQuestionnairesRes2 === void 0 ? void 0 : _esgQuestionnairesRes2.getEsgQuestionnaireResultsForVentures) !== null && _esgQuestionnairesRes !== void 0 ? _esgQuestionnairesRes : [];
    });
    var numberOfVentures = computed(function () {
      var _result$value, _result$value$getAcco, _result$value$getAcco2;
      return ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : (_result$value$getAcco = _result$value.getAccount) === null || _result$value$getAcco === void 0 ? void 0 : (_result$value$getAcco2 = _result$value$getAcco.ventureLinks) === null || _result$value$getAcco2 === void 0 ? void 0 : _result$value$getAcco2.length) || 0;
    });
    var numberOfCompletedQuestionnaires = computed(function () {
      var _esgQuestionnaires$va;
      return ((_esgQuestionnaires$va = esgQuestionnaires.value) === null || _esgQuestionnaires$va === void 0 ? void 0 : _esgQuestionnaires$va.filter(function (e) {
        return e.isCompleted;
      }).length) || 0;
    });
    var numberOfVenturesWithCriticalEsgIssues = computed(function () {
      var _esgQuestionnaires$va2;
      return ((_esgQuestionnaires$va2 = esgQuestionnaires.value) === null || _esgQuestionnaires$va2 === void 0 ? void 0 : _esgQuestionnaires$va2.filter(function (summary) {
        return summary.isCompleted === true && (summary.environmental <= 33 || summary.social <= 33 || summary.governance <= 33);
      }).length) || 0;
    });
    var numberOfVenturesWithCriticalDisclosureIssues = computed(function () {
      var _esgQuestionnaires$va3;
      return ((_esgQuestionnaires$va3 = esgQuestionnaires.value) === null || _esgQuestionnaires$va3 === void 0 ? void 0 : _esgQuestionnaires$va3.filter(function (summary) {
        return summary.isCompleted === true && summary.disclosure.hasRisk === true;
      }).length) || 0;
    });
    var keyFacts = [{
      label: $i18n.t("modules.dashboard.keyFacts.numberOfVentures"),
      value: numberOfVentures
    }, {
      label: $i18n.t("modules.dashboard.keyFacts.numberOfCompletedQuestionnaires"),
      value: numberOfCompletedQuestionnaires
    }, {
      label: $i18n.t("modules.dashboard.keyFacts.numberOfVenturesWithCriticalEsgIssues"),
      value: numberOfVenturesWithCriticalEsgIssues
    }, {
      label: $i18n.t("modules.dashboard.keyFacts.numberOfVenturesWithCriticalDisclosureIssues"),
      value: numberOfVenturesWithCriticalDisclosureIssues
    }];

    // const numberOfMetricAssignments = computed(() => {
    //   if (!props.metricAggregationAssignments) return 0
    //   return new Set(
    //     props.metricAggregationAssignments
    //       .flatMap((aggregation) => aggregation.metricAssignments)
    //       .map((assignment) => assignment.id)
    //   ).size
    // })

    // return {
    //   numberOfVentures,
    //   numberOfCompletedQuestionnaires,
    //   numberOfVenturesWithCriticalEsgIssues,
    //   numberOfVenturesWithCriticalDisclosureIssues,
    //   // numberOfMetricAssignments,
    // }

    return {
      __sfc: true,
      $i18n: $i18n,
      result: result,
      esgQuestionnairesResult: esgQuestionnairesResult,
      esgQuestionnaires: esgQuestionnaires,
      numberOfVentures: numberOfVentures,
      numberOfCompletedQuestionnaires: numberOfCompletedQuestionnaires,
      numberOfVenturesWithCriticalEsgIssues: numberOfVenturesWithCriticalEsgIssues,
      numberOfVenturesWithCriticalDisclosureIssues: numberOfVenturesWithCriticalDisclosureIssues,
      keyFacts: keyFacts
    };
  }
});